<template>
  <div class="main_box">
    <div class="main_bar">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <span class="currentSpan">
            投票状态：
            <span v-if="voteInfo.Status === 0"> 编辑中 </span>
            <span v-if="voteInfo.Status === 1"> 进行中 </span>
            <span v-if="voteInfo.Status === 3"> 已结束 </span>
          </span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="vote_step_box">
      <el-row :gutter="15">
        <el-col :span="6">
          <div class="check_success_box" v-if="basicCheck.IsComplete">
            <i class="el-icon-check"></i> 已完成
          </div>
          <div class="check_warning_box" v-if="!basicCheck.IsComplete">
            <i class="el-icon-close"></i>
            {{
              basicCheck.NoCompleteMessages == ''
                ? '基本信息不完善'
                : basicCheck.NoCompleteMessages
            }}
          </div>
          <a
            :class="{
              vote_step_item_active: isActive === 1,
              vote_step_item: isActive !== 1
            }"
            @click="stepClick(1)"
          >
            <span class="vote_step_num hidden-sm-and-down">
              <i class="iconfont icon-xiangmu"></i>
            </span>
            <div class="vote_step_content">
              <div class="vote_step_title">基本信息</div>
              <div class="vote_step_desc hidden-sm-and-down">
                投票标题、时间、规则等信息
              </div>
            </div>
          </a>
        </el-col>
        <el-col :span="6">
          <div class="check_success_box" v-if="projectCheck.IsComplete">
            <i class="el-icon-check"></i> 已添加选项
          </div>
          <div class="check_warning_box" v-if="!projectCheck.IsComplete">
            <i class="el-icon-close"></i>
            {{
              projectCheck.NoCompleteMessages == ''
                ? '未选投票选项'
                : projectCheck.NoCompleteMessages
            }}
          </div>
          <a
            :class="{
              vote_step_item_active: isActive === 3,
              vote_step_item: isActive !== 3
            }"
            @click="stepClick(3)"
          >
            <span
              class="vote_step_num hidden-sm-and-down"
              v-if="voteInfo.MeetingVerify !== 1"
            >
              <i class="iconfont icon-jibenxinxi"></i>
            </span>
            <span
              class="vote_step_num hidden-sm-and-down"
              v-if="voteInfo.MeetingVerify === 1"
            >
              <i class="iconfont icon-jibenxinxi"></i>
            </span>
            <div class="vote_step_content">
              <div class="vote_step_title">投票选项</div>
              <div class="vote_step_desc hidden-sm-and-down">设置投票选项</div>
            </div>
          </a>
        </el-col>
        <el-col :span="6">
          <div style="height: 16px"></div>
          <a
            :class="{
              vote_step_item_active: isActive === 4,
              vote_step_item: isActive !== 4
            }"
            @click="stepClick(4)"
          >
            <span class="vote_step_num hidden-sm-and-down">
              <i class="iconfont icon-shezhitianchong"></i>
            </span>
            <div class="vote_step_content">
              <div class="vote_step_title">其它设置</div>
              <div class="vote_step_desc hidden-sm-and-down">
                设置投票按钮、搜索信息等
              </div>
            </div>
          </a>
        </el-col>
        <el-col :span="6" v-if="voteInfo.Status === 0">
          <el-button
            type="primary"
            style="width: 80px; height: 70px; margin-top: 16px"
            :disabled="!isComplete"
            @click="startVote()"
          >
            开始投票
          </el-button>
        </el-col>
        <el-col :span="6">
          <el-button
            type="primary"
            style="width: 80px; height: 70px; margin-top: 16px"
            @click="endVote()"
            v-if="voteInfo.Status === 1"
          >
            结束投票
          </el-button>
          <el-button
            type="primary"
            style="width: 80px; height: 70px; margin-top: 16px"
            @click="resetVote()"
            v-if="
              userRole === 1 && (voteInfo.Status === 1 || voteInfo.Status === 3)
            "
          >
            重新投票
          </el-button>
        </el-col>
      </el-row>
    </div>
    <router-view :voteInfo="voteInfo" :meetingInfo="meetingInfo" />
  </div>
</template>

<script>
import voteManageApi from '../../../../api/vote/voteManage'
export default {
  data () {
    return {
      formTitle: '新增投票',
      isActive: 1,
      basicCheck: {
        IsComplete: false,
        NoCompleteMessages: '基本信息不完善'
      },
      projectCheck: {
        IsComplete: false,
        NoCompleteMessages: '未添加投票选项'
      },
      isComplete: false,
      voteInfo: {
        Status: null,
        MeetingVerify: 1
      },
      userRole: -1
    }
  },
  provide () {
    return {
      voteCheck: this.voteCheck,
      getVoteInfo: this.getVoteInfo,
      routeChange: this.routeChange
    }
  },
  props: ['meetingInfo'],
  inject: ['getMeetingVoteInfo'],
  methods: {
    goBack: function () {
      this.$router.push({ name: 'meetingVote', params: { mid: this.$route.params.mid } })
    },
    stepClick: function (step) {
      const _this = this
      _this.isActive = step
      switch (step) {
        case 1:
          _this.$router.push({ name: 'editPublicVoteBasic', params: { mid: _this.$route.params.mid, vid: _this.$route.params.vid } })
          break
        case 3:
          if (_this.$route.params.vid && _this.$route.params.vid !== '0') {
            _this.$router.push({ name: 'editPublicVoteProject', params: { mid: _this.$route.params.mid, vid: _this.$route.params.vid } })
          } else {
            _this.isActive = 1
            _this.$message({
              showClose: true,
              type: 'warning',
              message: '请先完善投票基本信息',
              customClass: 'custom_message'
            })
          }
          break
        case 4:
          if (_this.$route.params.vid && _this.$route.params.vid !== '0') {
            _this.$router.push({ name: 'editPublicVoteSetting', params: { mid: _this.$route.params.mid, vid: _this.$route.params.vid } })
          } else {
            _this.isActive = 1
            _this.$message({
              showClose: true,
              type: 'warning',
              message: '请先完善投票基本信息',
              customClass: 'custom_message'
            })
          }
          break
      }
    },
    routeChange () {
      switch (this.$route.name) {
        case 'editPublicVoteBasic':
          this.isActive = 1
          break
        case 'editPublicVoteProject':
          this.isActive = 3
          break
        case 'editPublicVoteSetting':
          this.isActive = 4
          break
      }
      this.stepClick(this.isActive)
    },
    voteCheck: function () {
      const _this = this
      voteManageApi.checkPublicVote({ VoteId: _this.$route.params.vid }).then(data => {
        const checkInfo = data
        checkInfo.forEach(function (item, index) {
          if (item.Step === 'basic') {
            _this.basicCheck.IsComplete = item.IsComplete
            if (!_this.basicCheck.IsComplete) {
              _this.basicCheck.NoCompleteMessages = ''
              item.NoCompleteMessages.forEach(function (mItem, mIndex) {
                _this.basicCheck.NoCompleteMessages += mItem + ' '
              })
            }
          }
          if (item.Step === 'project') {
            _this.projectCheck.IsComplete = item.IsComplete
            if (!_this.projectCheck.IsComplete) {
              _this.projectCheck.NoCompleteMessages = ''
              item.NoCompleteMessages.forEach(function (mItem, mIndex) {
                _this.projectCheck.NoCompleteMessages += mItem + ' '
              })
            }
          }
        })
        if (_this.basicCheck.IsComplete && _this.projectCheck.IsComplete) {
          _this.isComplete = true
        } else {
          _this.isComplete = false
        }
      }).catch(err => {
        return err
      })
    },
    startVote: function () {
      const _this = this
      _this.$confirm('确认开始该投票吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = _this.openLoading('投票启动中…')
        voteManageApi.startPublicVote({
          VoteId: _this.$route.params.vid
        }).then(data => {
          //   const voteNum = data
          _this.$message({
            type: 'success',
            message: '投票启动成功！',
            customClass: 'custom_message'
          })
          _this.getVoteInfo()
          _this.getMeetingVoteInfo()
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消开始投票操作',
          customClass: 'custom_message'
        })
      })
    },
    endVote: function () {
      const _this = this
      _this.$confirm('确认结束该投票吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = _this.openLoading('投票结束中…')
        voteManageApi.endPublicVote({
          VoteId: _this.$route.params.vid
        }).then(data => {
          _this.$message({
            type: 'success',
            message: '投票结束成功！',
            customClass: 'custom_message'
          })
          _this.getVoteInfo()
          _this.getMeetingVoteInfo()
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消结束投票操作',
          customClass: 'custom_message'
        })
      })
    },
    resetVote: function () {
      const _this = this
      _this.$confirm('确认重置该投票吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = _this.openLoading('投票重置中…')
        voteManageApi.resetPublicVote({
          VoteId: _this.$route.params.vid
        }).then(data => {
          _this.$message({
            type: 'success',
            message: '投票重置成功！',
            customClass: 'custom_message'
          })
          _this.getVoteInfo()
          _this.getMeetingVoteInfo()
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消重置投票操作',
          customClass: 'custom_message'
        })
      })
    },
    getVoteInfo: function () {
      const _this = this
      _this.openLoading()
      if (_this.$route.params.vid !== '0') {
        voteManageApi.getVoteDetail({
          voteId: _this.$route.params.vid
        }).then(data => {
          _this.voteInfo = data
          _this.openLoading().close()
        }).catch(err => {
          _this.openLoading().close()
          return err
        })
      } else {
        _this.voteInfo.Status = 0
        _this.voteInfo.MeetingVerify = _this.meetingInfo.Verify
        _this.openLoading().close()
      }
    },
    getCurrentUserRole: function () {
      this.$api.userInfo.getCurrentUserRole().then(data => {
        this.userRole = data
      }).catch(err => {
        return err
      })
    }
  },
  mounted () {
    // const _this = this
    // this.$root.$on('routeChange', function () {
    //   _this.routeChange()
    // })
    // this.$root.$on('voteCheck', function () {
    //   _this.voteCheck()
    // })
    // this.$root.$on('getVoteInfo', function () {
    //   _this.getVoteInfo()
    // })
  },
  created () {
    if (this.$route.params.vid === '0') {
      this.formTitle = '新增投票'
      // this.voteCheck()
    } else {
      this.formTitle = '编辑投票'
    }
    this.routeChange()
    this.getVoteInfo()
    this.getCurrentUserRole()
  },
  watch: {
    $route () {
      if (this.$route.name === 'createVoteBasic' && this.$route.params.vid === '0') {
        this.basicCheck = {
          IsComplete: false,
          NoCompleteMessages: '基本信息不完善'
        }
        this.projectCheck = {
          IsComplete: false,
          NoCompleteMessages: '未选待评项'
        }
      }
    }
  }
}
</script>
<style lang="less">
.vote_step_box {
  width: 100%;
  padding: 10px 0px 15px 0px;
}
.vote_step_item {
  width: 100%;
  height: 70px;
  border-radius: 3px;
  background-color: #fff;
  color: #5e6d82;
  cursor: pointer;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
}
.vote_step_item:hover {
  opacity: 0.6;
  filter: alpha(opacity=60);
}
.vote_step_item_active {
  width: 100%;
  height: 70px;
  border-radius: 3px;
  background-color: #409eff;
  //background-color: #67c23a;
  color: #fff;
  cursor: pointer;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
}
.vote_step_item_active:hover {
  //background-color: #85ce61;
  background-color: #66b1ff;
}
.vote_step_item_complete {
  width: 100%;
  height: 82px;
  border-radius: 3px;
  background-color: #67c23a;
  color: #fff;
  cursor: pointer;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
}
.vote_step_item_complete:hover {
  background-color: #85ce61;
}
.vote_step_num {
  font-style: italic;
  //   font-size: 40px;
  font-weight: 900;
  padding: 0px 15px 0px 0px;
  font-family: Arial, Verdana, Sans-serif;
  letter-spacing: 8px;
}
.vote_step_num i {
  font-size: 26px;
}
.vote_step_icon {
  font-size: 20px;
  margin-right: 20px;
  position: absolute;
  top: 3px;
  left: 15px;
  color: #67c23a;
}
.vote_step_content {
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}
.vote_step_title {
  font-size: 18px;
  font-weight: 700;
}
.vote_step_desc {
  font-size: 12px;
}
.check_success_box {
  height: 16px;
  width: 120px;
  background-image: url('../../../../assets/images/vote/success_tip1.png');
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 6px 6px 0px 0px;
  color: #fff;
  text-align: left;
  font-size: 8px;
  padding: 0px 5px;
  word-spacing: 3px;
}
.check_warning_box {
  height: 16px;
  width: 180px;
  background-image: url('../../../../assets/images/vote/warning_tip1.png');
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 6px 6px 0px 0px;
  color: #fff;
  text-align: left;
  font-size: 8px;
  padding: 0px 5px;
  word-spacing: 3px;
}
.check_none_box {
  height: 16px;
  width: 90px;
  border-radius: 6px 6px 0px 0px;
}
</style>
